import { fileUrl, youtubeEmbed } from "@/lib/media";

export default function MediaEmbed({ media }) {
  if (!media || !media.url) return null;
  const { type, source, url } = media;

  if (type === "video") {
    const yt = source === "embed" ? youtubeEmbed(url) : null;
    if (yt) {
      return (
        <div className="aspect-video w-full rounded-xl overflow-hidden border border-border">
          <iframe
            data-testid="media-video-embed"
            src={yt}
            title="video"
            className="w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      );
    }
    return (
      <video data-testid="media-video" controls src={fileUrl(url)} className="w-full rounded-xl border border-border" />
    );
  }

  if (type === "audio") {
    return <audio data-testid="media-audio" controls src={fileUrl(url)} className="w-full" />;
  }

  if (type === "image") {
    return (
      <img
        data-testid="media-image"
        src={fileUrl(url)}
        alt={media.title || "media"}
        className="rounded-xl border border-border max-h-72 object-cover"
      />
    );
  }

  if (type === "pdf" || type === "document") {
    return (
      <iframe
        data-testid="media-pdf"
        src={fileUrl(url)}
        title={media.title || "pdf"}
        className="w-full h-[28rem] rounded-xl border border-border bg-muted"
      />
    );
  }
  return null;
}
